import React from 'react';
import './RetailerDetailsSkeleton.scss';

const RetailerDetailsSkeleton = () => {
    return (
        <div className="retailer-details-skeleton">
            {/* Tab Skeleton */}
            <div className="skeleton-tabs">
                <div className="skeleton-tab"></div>
                <div className="skeleton-tab"></div>
            </div>

            {/* Two Column Form Layout */}
            <div className="skeleton-details-container">
                {/* Left Column */}
                <div className="skeleton-column">
                    {/* Shop Picture */}
                    <div className="skeleton-field">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-image"></div>
                    </div>

                    {/* Regular Fields */}
                    {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                        <div key={item} className="skeleton-field">
                            <div className="skeleton-label"></div>
                            <div className="skeleton-input"></div>
                        </div>
                    ))}
                </div>

                {/* Right Column */}
                <div className="skeleton-column">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
                        <div key={item} className="skeleton-field">
                            <div className="skeleton-label"></div>
                            <div className="skeleton-input"></div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Close Button */}
            <div className="skeleton-button-container">
                <div className="skeleton-button"></div>
            </div>
        </div>
    );
};

export default RetailerDetailsSkeleton;
